<template>

  <section class="box-userprofile">
    <SignedTitle
      title="Mi Perfil"
      description="En tu perfil podrás completar tus datos como inversionista de Ekscelenko en
        Cumplo y así realizar acciones en la plataforma.">
    </SignedTitle>
      <transition name="fade">
        <div v-if="!isUserComplete">
          <UserProfileForm></UserProfileForm>
        </div>
        <div v-else>
          <UserProfileResume></UserProfileResume>
        </div>
      </transition>
  </section>

</template>

<script>

import SignedTitle from '@/components/SignedTitle'
import Preloader from '@/components/Preloader'

import UserProfileForm from './userProfile/UserProfileForm'
import UserProfileResume from './userProfile/UserProfileResume'

import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

import mixins from '@/mixins/index'

Vue.use(VueSweetalert2)

export default {
  name: 'UserProfile',
  metaInfo () {
    return {
      title: 'Mi Perfil'
    }
  },
  components: {
    SignedTitle,
    Preloader,
    UserProfileForm,
    UserProfileResume
  },
  mixins: [mixins],
  data () {
    return {
      currentStep: 0,
      userResumeData: {},
      isUserComplete: false
    }
  },
  created: function () {
    const step = this.$store.getters.getCurrentStep
    this.currentStep = step
    this.handleForm(step)
  },
  methods: {
    handleForm: function (currentStep) {
      let isInvestor = this.$store.getters.getIsInvestor
      if (isInvestor === false) {
        Vue.swal({
          type: 'warning',
          title: 'Completa tu perfil',
          text: 'Por favor apóyanos completando tu perfil para realizar ' +
            'acciones dentro de la plataforma.',
          showCloseButton: true,
          showConfirmButton: true,
          confirmButtonColor: '#00ba68',
          confirmButtonText: 'Continuar'
        })
      } else if (isInvestor === true && currentStep === -1) {
        this.isUserComplete = true
      }
    }
  }
}

</script>

<style scoped lang="scss">

.box-userprofile {
  margin: 100px 0 50px;
  min-height: 400px;

  .preloader {
    margin: 7rem auto 5rem;
  }

  .box-title {
    padding: 4rem 0 2rem;
    border-bottom: 1px solid $grey;

    .maintitle {
      margin: 0;
      font-size: 2.6em;
    }

    .legend {
      margin: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/UserProfile.vue